import { cn } from "@app/lib/utils";
import { VideoPlayIcon } from "@assets/icons";
import videoImage from "@assets/images/home/video.jpg";
import { aboutUsVideoPortal } from "../portal-atoms.ts";

export default function AboutUsVideo() {
  return (
    <div className="relative">
      <img
        src={videoImage}
        alt="Who We Are"
        className={cn(
          "rounded-[100px] object-cover object-left max-lg:max-h-[368px] rtl:scale-x-[-1]",
        )}
      />
      <div className="absolute inset-0 z-20 h-[10%] bg-gradient-to-b from-dark-blue to-transparent"></div>
      <div className="absolute inset-0 z-20 bg-[radial-gradient(circle,rgba(0,_25,_89,_0)_0%,_rgba(0,_25,_89,_1)_90%)]" />
      <div className="absolute inset-0 bottom-0 z-20 bg-gradient-to-t from-dark-blue to-transparent"></div>
      <button
        type="button"
        title="Play Video"
        aria-label="Play Video"
        onClick={aboutUsVideoPortal.open}
      >
        <VideoPlayIcon className="absolute left-1/2 top-1/2 z-20 -translate-x-1/2 -translate-y-1/2" />
      </button>
    </div>
  );
}
